<template>
  <div>
    <vue-goodshare-telegram :page_url="url" has_icon></vue-goodshare-telegram>
    <vue-goodshare-viber :page_url="url" has_icon></vue-goodshare-viber>
    <vue-goodshare-whats-app :page_url="url" has_icon></vue-goodshare-whats-app>
    <vue-goodshare-line :page_url="url" has_icon></vue-goodshare-line>
  </div>
</template>

<script>
// Import vue-goodshare single elements
import VueGoodshareTelegram from 'vue-goodshare/src/providers/Telegram';
import VueGoodshareViber from 'vue-goodshare/src/providers/Viber';
import VueGoodshareWhatsApp from 'vue-goodshare/src/providers/WhatsApp';
import VueGoodshareLine from 'vue-goodshare/src/providers/Line';

export default {
  data() {
    return {
    };
  },
  props: ['url'],
  components: {
    VueGoodshareTelegram,
    VueGoodshareViber,
    VueGoodshareWhatsApp,
    VueGoodshareLine,
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// ShareMobile.vue?2e247fa4